// BotWork Design Tokens — pixel-perfect from Figma design
// All values extracted directly from Figma node 59:3657

// ── Colors ───────────────────────────────────────────────────────

export const colors = {
  bg: "#171717",
  sidebar: "#171717",
  mainArea: "#201F1F",
  surface: "rgba(255,255,255,0.04)",
  surfaceHover: "rgba(255,255,255,0.06)",
  surfaceActive: "rgba(255,255,255,0.08)",
  border: "rgba(255,255,255,0.06)",
  borderHover: "rgba(255,255,255,0.12)",
  borderFocus: "rgba(134,53,246,0.4)",
  overlay: "rgba(0,0,0,0.6)",
  userBubble: "rgba(255,255,255,0.05)",
  // Input bar
  inputBg: "rgba(229,226,225,0.06)",
  inputBorder: "#353535",
  // Chips
  chipBg: "#353534",
  chipBorder: "rgba(75,68,85,0.1)",
  // Sidebar elements
  newTaskBg: "#2D2C2C",
  signinBorder: "#2E2A33",
  userCardBorder: "#2C2B2B",
} as const;

export const text = {
  primary: "#ececec",
  heading: "#F4F4F4",
  body: "#E5E2E1",
  nav: "#F6F5F5",
  muted: "#CDC2D8",
  placeholder: "rgba(205,194,216,0.5)",
  disclaimer: "rgba(205,194,216,0.4)",
  secondary: "rgba(236,236,236,0.7)",
  faint: "rgba(236,236,236,0.3)",
} as const;

export const accent = {
  violet: "#8635F6",
  violetHover: "#9b50ff",
  violetMuted: "rgba(134,53,246,0.15)",
  violetGlow: "rgba(134,53,246,0.1)",
  sky: "#86BBD8",
  honey: "#F6AE2D",
  orange: "#F26419",
  success: "#4ADE80",
  error: "#F87171",
} as const;

// ── Typography ───────────────────────────────────────────────────

export const font = {
  heading: "var(--font-plus-jakarta), system-ui, -apple-system, sans-serif",
  body: "var(--font-plus-jakarta), system-ui, -apple-system, sans-serif",
} as const;

export const typo = {
  headingXl: { fontSize: 28, fontWeight: 700, lineHeight: "42px", letterSpacing: "-0.7px" },
  headingLg: { fontSize: 20, fontWeight: 600, lineHeight: 1.3 },
  headingSm: { fontSize: 14, fontWeight: 600, lineHeight: "21px" },
  body: { fontSize: 15, fontWeight: 400, lineHeight: 1.6 },
  bodySm: { fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
  bodyLg: { fontSize: 16, fontWeight: 400, lineHeight: "26px" },
  subtitle: { fontSize: 18, fontWeight: 400, lineHeight: "29.25px" },
  label: { fontSize: 12, fontWeight: 600, lineHeight: 1.3, textTransform: "uppercase" as const, letterSpacing: "0.05em" },
  recentsLabel: { fontSize: 10, fontWeight: 700, lineHeight: "15px", letterSpacing: "1px" },
  recentTitle: { fontSize: 14, fontWeight: 500, lineHeight: "20px" },
  recentSubtitle: { fontSize: 11, fontWeight: 400, lineHeight: "16.5px" },
  nav: { fontSize: 14, fontWeight: 600, lineHeight: "21px" },
  chip: { fontSize: 14, fontWeight: 400, lineHeight: "20px" },
  disclaimer: { fontSize: 11, fontWeight: 600, lineHeight: "16.5px", letterSpacing: "0.275px", textTransform: "uppercase" as const },
} as const;

// ── Spacing ──────────────────────────────────────────────────────

export const spacing = {
  "0": 0,
  "1": 4,
  "2": 8,
  "3": 12,
  "4": 16,
  "5": 20,
  "6": 24,
  "8": 32,
  "10": 40,
  "12": 48,
  "16": 64,
} as const;

// ── Border Radius ────────────────────────────────────────────────

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  "2xl": 24,
  sendBtn: 14,
  full: 9999,
} as const;

// ── Shadows ──────────────────────────────────────────────────────

export const shadows = {
  glow: "0 0 20px rgba(134,53,246,0.2)",
  glowStrong: "0 0 30px rgba(134,53,246,0.3)",
  modal: "0 24px 48px rgba(0,0,0,0.4)",
  card: "0 1px 3px rgba(0,0,0,0.2)",
} as const;

// ── Transitions ──────────────────────────────────────────────────

export const transitions = {
  fast: "150ms ease",
  normal: "200ms ease",
  slow: "300ms ease",
} as const;

// ── Layout ───────────────────────────────────────────────────────

export const layout = {
  sidebarWidth: 260,
  sidebarCollapsed: 91,
  contentMaxWidth: 720,
  inputMaxWidth: 720,
} as const;
